<template>
    <h2>{{ title }}</h2>
    <h5 v-if="description">{{ description }}</h5>
    <ul class="contact__list">
        <StoryblokComponent v-for="contact in contacts" :key="contact._uid" :blok="{ ...contact, infoText }" />
    </ul>
</template>
<script setup lang="ts">
defineProps<{ title: string; description: string; contacts: any[]; _uid: string; infoText?: string }>();
</script>
